import type { WizardCompletionDto } from '@onboarding/application/dtos';
import type { IWizardStatusPort } from '@onboarding/application/ports';
import type { OnboardingHttpClientType } from '@onboarding/infrastructure/api';

/**
 * Concrete implementation of IWizardStatusPort.
 * Orchestrates HTTP client to fulfill application contracts.
 */
export const createWizardStatusRepository = (props: { httpClient: OnboardingHttpClientType }): IWizardStatusPort => {
  const { httpClient } = props;

  const completeWizard = async (): Promise<WizardCompletionDto> => {
    const response = await httpClient.completeWizard();
    return {
      storeUuid: response.storeUuid,
      wizardCompleted: response.wizardCompleted,
    };
  };

  return { completeWizard };
};
